module.exports = __webpack_public_path__ + "img/stock1.34530a14.png";